import config from "../../config/config";
import axios from "axios";
import { getToken } from "../../common";

export const accessBuyerAccountAPI = async (userId) => {
  return await axios({
    method: "post",
    url: `${config.api.base_url}dashboard/buyers/${userId}/access-account`,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default accessBuyerAccountAPI;
